// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import download from './down.js'
Vue.prototype.$down = download
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/my-element.css';
import './assets/css/public.css';
import Vuex from 'vuex'
Vue.use(Vuex)
Vue.prototype.imgUrl = 'https://svip.fengpu.com/gyzhqyimgs/'
Vue.prototype.bUrl = 'https://svip.fengpu.com/'
// Vue.prototype.imgUrl = 'https://gyzhqy.areacloud.cn/gyzhqyimgs/'
// Vue.prototype.bUrl = 'https://gyzhqy.areacloud.cn/'
Vue.use(ElementUI);
import declare from '@/components/NotiDeclare/declare'
Vue.component('declare', declare);
import declare2 from '@/components/NotiDeclare/declare2'
Vue.component('declare2', declare2);
import addappeal from '@/components/user/form/addappeal'
Vue.component('addappeal', addappeal);
import addsurvey2 from '@/components/user/form/addsurvey2'
Vue.component('addsurvey2', addsurvey2);
import addus from '@/components/user/form/addus'
Vue.component('addus', addus);
import addsurvey from '@/components/user/form/addsurvey'
Vue.component('addsurvey', addsurvey);
import addvisit from '@/components/user/form/addvisit'
Vue.component('addvisit', addvisit);
import editsurvey2 from '@/components/user/form/editsurvey2'
Vue.component('editsurvey2', editsurvey2);
import editsurvey from '@/components/user/form/editsurvey'
Vue.component('editsurvey', editsurvey);
import editvisit from '@/components/user/form/editvisit'
Vue.component('editvisit', editvisit);
axios.interceptors.request.use(config => {
  config.headers.common['XX-Device-Type'] = 'web'
//config.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
  if (localStorage.getItem('gyzhqy_token')) {
    config.headers.common['XX-Token'] = localStorage.getItem('gyzhqy_token')
  }
  return config;
}, error => {
  return Promise.reject(error);
});
axios.interceptors.response.use(
  response => {
  	console.log(response.data.code,"response")
  	if(response.data.code==10001){
  		localStorage.setItem('gyzhqy_token', null);
      router.replace({path: '/',query:{loginto:parseInt(Math.random()*1000+1)} })
  	}
     return response;
  },
  error => {
  	alert('网络请求异常')
    if (error.response) {
      switch (error.response.status) {
        case 401:
        case 500:
          localStorage.setItem('gyzhqy_token', null);
          router.replace({
            path: '/',
            query: { redirect: router.currentRoute.fullPath }
          })
      }
    }
    return Promise.reject(error.response.data)
});
Vue.prototype.$ajax = axios
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store:new Vuex.Store({
  	state:{scn:'登录'},
  	mutations:{
  		mcn(state,scn){
  			state.scn = scn
  		}
    }
  }),
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js